import MessageGearsForm from './message-gears-form';
import { IMessageGearsForm } from '../interfaces';
import { Popup } from '../../../ui/popup/popup';
import {useState} from "react";


/*
Usage Examples:
<div
    class="my-4"
    data-form-name="GeneralSingup"
    data-show-names="false"
    data-email-label="Enter your email"
    data-submit-label="Subscribe"
    data-popup="false"
    data-hide-on-submit="false"
    data-show-terms="true"
    data-save-nodeguid="true"
    data-centered="false"
    data-width="300px"
    data-height="300px"
>
    <div class="text-center text-black">
        <div class="text-2xl font-bold">Waves Premium Content</div>
        <p class="mb-10">Enter a valid email to view this page</p>
    </div>
</div>

Popup example:
https://dev13.waves.com/country-mixing-masterclass-nick-brophy
 */

const MessageGears = (props: IMessageGearsForm) => {

    const [showPopup, setShowPopup] = useState(!props.visited);

    return (
        <>
            {
                props.isInPopup && showPopup &&
                <Popup
                    width={props.width || '500px'}
                    height={props.height || '300px'}
                    canBeClosed={false}
                    close={() => {
                        setShowPopup(false);
                    }}>
                    <div className="flex items-center justify-center h-full px-8">
                        <MessageGearsForm {...props} />
                    </div>
                </Popup>
            }

            {
                !props.isInPopup && <MessageGearsForm {...props} />
            }
        </>
    )
};

export default MessageGears;
